// extracted by mini-css-extract-plugin
export default {"block":"CartLayout_block__ilr6X","container":"CartLayout_container__RIepl","relatedProducts":"CartLayout_relatedProducts__HL29k"};